import React, { useEffect, useState, Fragment } from "react";
import {
  Button,
  Card,
  CardHeader,
  CardText,
  CardTitle,
  Col,
  Form,
  FormFeedback,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
  Spinner,
} from "reactstrap";
import { Controller, useForm } from "react-hook-form";
import toast from "react-hot-toast";
import { checkIsValid } from "../../../../../utility/helpers";
import { filtrarTiposDeVenta } from "../../../../../utility/utils";
import {
  InputCurrency,
  InputNumber,
  InputText,
} from "../../../../components/inputs";
import Select from "react-select";
import { producTypesdb } from "../../db/producTypes";
import { unitTypes } from "../../db/unitOfMeasure";
import { TypesOfsale } from "../../db/TypesOfsale";
import { useSelector } from "react-redux";
import FormSchemaValidations from "./schema-validations";
import { yupResolver } from "@hookform/resolvers/yup";
import CurrencyInput from "react-currency-input-field";

//import axios from "axios";

const EditProducService = ({
  isOpen,
  handleClose,
  item,
  itemList,
  setItem,
  invoiceId,
}) => {
  const [loading, setLoading] = useState(false);
  const [checked, setChecked] = useState(false);
  const { receptor, products, measurementUnits, saleTypes } = useSelector(
    (state) => state.invoiceIssuance
  );
  const userInfo = useSelector((state) => state.businessManager);

  const {
    control,
    formState,
    setValue,
    reset,
    setError,
    handleSubmit,
    formState: { errors },
  } = useForm({
    mode: "all",
    reValidateMode: "onChange",
    resolver: yupResolver(FormSchemaValidations),
  });

  const filteredOptions = producTypesdb.filter((option) => {
    if (userInfo?.data?.typeOffer?.value === "Producto") {
      setValue("prodType", { value: "Producto", label: "Producto" });
      return option.value === "Producto";
    }
    if (userInfo?.data?.typeOffer?.value === "Servicio") {
      setValue("prodType", { value: "Servicio", label: "Servicio" });
      return option.value === "Servicio";
    }
    return true;
  });

  useEffect(() => {
    if (item) {
      setValue("productCode", item.productCode);
      setValue("prodType", item.prodType);
      setValue("productName", item.productName);
      setValue("quantity", item.quantity);
      setValue("price", item.price);
      setValue("discount", item.discount);
      //setValue('accept', item ? item?.accept : true);
      setValue("unitOfMeasure", item.unitOfMeasure);
      setValue("TypeOfSale", item.TypeOfSale);
      setChecked(item?.accept);
    } else {
      reset();
    }
  }, [item]);

  const setIsChecked = (e) => {
    setChecked(e.target.checked);
  };

  useEffect(() => {
    console.log(checked);
    //setValue('accept', checked);
  }, [checked]);

  const onSubmit = async (dataForm) => {
    if (/*checkIsValid(dataForm)*/ true) {
      try {
        console.log("receptor?.dteType?.value: ", receptor?.dteType?.value)
        if (invoiceId === "note" || invoiceId === "debit-note") {
          const selectedProduct = products.find(
            (product) => product.id === item.id
          );

          if (
            receptor?.dteType?.value === "06" &&
            (parseFloat(dataForm.price) < parseFloat(selectedProduct.price) ||
              parseFloat(dataForm.quantity) <
                parseFloat(selectedProduct.quantity) ||
              parseFloat(dataForm.discount) >
                parseFloat(selectedProduct.discount))
          ) {
            toast.error("El valor de la factura no debe disminuir");
            return;
          }

          if (
            receptor?.dteType?.value === "05" &&
            (parseFloat(dataForm.price) > parseFloat(selectedProduct.price) ||
              parseFloat(dataForm.quantity) >
                parseFloat(selectedProduct.quantity) ||
              parseFloat(dataForm.discount) <
                parseFloat(selectedProduct.discount))
          ) {
            toast.error("El valor de la factura no debe aumentar");
            return;
          }

          const itemCode = item.productCode;

          const updatedData = itemList.map((item) => {
            if (item.productCode === itemCode) {
              return { ...item, ...dataForm };
            }
            return item;
          });
          setItem(updatedData);

          toast.success("Registro actualizado con exito");
          handleClose(false);
        } else {
          const itemCode = item.id;
          dataForm.quantity = Number(dataForm.quantity);
          dataForm.price = Number(dataForm.price);
          const updatedData = itemList.map((item) => {
            if (item.id === itemCode) {
              return { ...item, ...dataForm };
            }
            return item;
          });
          setItem(updatedData);

          toast.success("Registro actualizado con exito!");
          handleClose(false);
        }
      } catch (e) {
        console.log(e);
        setLoading(false);
        toast.error(
          `Ha ocurrido un error: ${e.response.data.title || e.message}`
        );
        reset();
      }
    } else {
      toast.error("completa los campos");
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      toggle={() => handleClose(false)}
      className="modal-dialog-centered modal-lg"
    >
      <ModalHeader
        className="bg-transparent"
        toggle={() => handleClose(false)}
      ></ModalHeader>
      <ModalBody className="px-sm-5 mx-50 pb-5">
        <div className="text-center mb-2">
          <h1 className="mb-1">Editar area</h1>
          <p>Editar area con los datos correspondientes.</p>
        </div>

        {loading ? (
          <Row>
            <div className="col-12 px-2 py-4 text-center">
              <Spinner size="lg" />
              <CardText className={"py-1 fs-5"}>Actualizando area...</CardText>
            </div>
          </Row>
        ) : (
          <Fragment>
            <Form onSubmit={handleSubmit(onSubmit)}>
              <Row
                className="mx-0"
                style={{ paddingTop: "2%", paddingLeft: "5%" }}
              >
                <Col>
                  <Label className="me-1">Tipo de producto*</Label>
                  <Controller
                    name="prodType"
                    control={control}
                    render={({ field }) => (
                      <>
                        <Select
                          {...field}
                          options={filteredOptions}
                          //defaultValue={item?.prodType ? { value: item?.prodType, label: item?.prodType } : null}
                          /*onChange={(e) => {
                        field.onChange(e.value)
                    }}*/
                        />
                        {errors.dteType && (
                          <FormFeedback className="d-block">
                            {errors.dteType.message}
                          </FormFeedback>
                        )}
                      </>
                    )}
                  />
                </Col>

                <Col>
                  <InputNumber
                    label={"Código de producto/servicio"}
                    errors={errors}
                    control={control}
                    disabled={true}
                    options={{
                      id: "productCode",
                      name: "productCode",
                      startWithCero: true,
                    }}
                  />
                </Col>
                <Col>
                  <InputText
                    label={"Nombre de producto/servicio*"}
                    errors={errors}
                    options={{
                      control,
                      id: "productName",
                      name: "productName",
                    }}
                  />
                </Col>
              </Row>
              <Row
                className="mx-0"
                style={{ paddingTop: "2%", paddingLeft: "5%" }}
              >
                <Col>
                  <InputNumber
                    label={"Cantidad*"}
                    errors={errors}
                    control={control}
                    options={{
                      id: "quantity",
                      name: "quantity",
                      startWithCero: true,
                    }}
                  />
                </Col>
                <Col>
                  <Label className="me-1">Unidad de medida*</Label>
                  <Controller
                    name="unitOfMeasure"
                    control={control}
                    render={({ field }) => (
                      <>
                        <Select
                          {...field}
                          options={measurementUnits}
                          //defaultValue={item?.unitOfMeasure ? { value: item?.unitOfMeasure, label: item?.unitOfMeasure } : null}
                          //onChange={(e) => {
                          //    field.onChange(e.value)
                          //setFilterProps({ ...filterProps, codeType: e.value})
                          //setValue('unitOfMeasure', e.value)
                          //}}
                        />
                        {errors.EconomicActivity && (
                          <FormFeedback className="d-block">
                            {errors.EconomicActivity.message}
                          </FormFeedback>
                        )}
                      </>
                    )}
                  />
                </Col>

                <Col>
                  <Label className="me-1">Tipo de venta*</Label>
                  <Controller
                    name="TypeOfSale"
                    control={control}
                    render={({ field }) => (
                      <>
                        <Select
                          {...field}
                          options={filtrarTiposDeVenta(saleTypes)}
                          //defaultValue={item?.TypeOfSale ? { value: item?.TypeOfSale, label: item?.TypeOfSale } : null}

                          /*onChange={(e) => {
                            field.onChange(e.value)
                        }}*/
                        />
                        {errors.EconomicActivity && (
                          <FormFeedback className="d-block">
                            {errors.EconomicActivity.message}
                          </FormFeedback>
                        )}
                      </>
                    )}
                  />
                </Col>
              </Row>

              <Row
                className="mx-0"
                style={{ paddingTop: "2%", paddingLeft: "5%" }}
              >
                <Col>
                <Label className="me-1">
                    Precio*
                </Label>
                  {/* <InputCurrency
                        label={"Precio*"}
                        errors={errors}
                        control={control}
                        options={{
                        id: 'price',
                        name: 'price',
                        startWithCero: true,
                        //maxLength: filterProps.codeType === 'dui' ? 9 : 14
                        }}
                    /> */}

                  <Controller
                    name="price"
                    control={control}
                    rules={{ required: "El precio es requerido" }} // Reglas de validación
                    render={({ field: { onChange, value, ref } }) => (
                      <>
                        <CurrencyInput
                          id="input-price"
                          name="price"
                          placeholder="Por favor ingrese un número"
                          value={value} // Valor actual del input
                          decimalsLimit={2}
                          groupSeparator=","
                          decimalSeparator="."
                          prefix="$"
                          className={`form-control ${
                            errors.price ? "is-invalid" : ""
                          }`} // Aplica estilos de reactstrap
                          onValueChange={(value) => onChange(value)} // Actualiza el valor del formulario
                          inputRef={ref} // Referencia para react-hook-form
                        />
                        {errors.price && (
                          <FormFeedback className="d-block">
                            {errors.price.message}
                          </FormFeedback>
                        )}
                      </>
                    )}
                  />
                </Col>
                <Col>
                  <InputNumber
                    label={"Aplicar descuento"}
                    errors={errors}
                    control={control}
                    type="percent"
                    //disabled={!filterProps.codeType}
                    options={{
                      id: "discount",
                      name: "discount",
                      startWithCero: true,
                      //maxLength: filterProps.codeType === 'dui' ? 9 : 14
                    }}
                  />
                  {errors.discount && (
                    <FormFeedback className="d-block">
                      {errors.discount.message}
                    </FormFeedback>
                  )}
                </Col>
                {/* <Col style={{display: "flex", alignItems: "flex-end"}}>
                    <Label check>
                            <Controller
                                name="accept"
                                control={control}
                                render={({ field }) => (
                                    <Input
                                        {...field}
                                        type="checkbox"
                                        id="accept"
                                        checked={checked} 
                                        onChange={setIsChecked}
                                        invalid={!!errors.accept}
                                    />
                                )}
                            />{' '}
                            Aplica impuesto
                        </Label>
                    </Col> */}
              </Row>

              <Row className="mx-0" style={{ paddingLeft: "5%" }}>
                <Col className="d-flex align-items-left justify-content-sm-left my-3">
                  <Button
                    style={{ size: "10px", width: "200px" }}
                    color="primary"
                    type="submit"
                    //onClick={handleClearFilters}
                  >
                    Guardar
                  </Button>
                </Col>
              </Row>
            </Form>
          </Fragment>
        )}
      </ModalBody>
    </Modal>
  );
};

export default EditProducService;
